export function initTableListFilters(table_selector, portlet_selector, onChange) {
	let portlet = $(portlet_selector);
	let table = portlet.find(table_selector);

	window.initFootable(table, "");

	// Filter plancher
	portlet.find(".form_filter_floor").on("click", function () {
		portlet.find(".filter_page").val("1");
		portlet.find("#filter_value").val("");
		portlet.find(".filter_checkbox").each(function () {
			$(this).find("input:radio").removeAttr("checked");
		});
		onChange();
	});

	// Surligner la ligne sélectioné
	table.on("click", "td", function () {
		var tr = $(this).parent();
		table.find("tr").removeClass("selected");
		tr.addClass("selected");
	});

	// Filter change
	portlet.find(".form_filter").on("change", function () {
		portlet.find(".filter_page").val("1");
		onChange();
	});

	// Sort order change
	portlet.find(".sorting, .sorting_asc, .sorting_desc").on("click", function () {
		if ($(this).attr("column-name") == portlet.find(".filter_order_column").val()) {
			if (portlet.find(".filter_order_orientation").val() == "ASC") {
				portlet.find(".filter_order_orientation").val("DESC");
			} else {
				portlet.find(".filter_order_orientation").val("ASC");
			}
		} else {
			var default_order = $(this).data("default-order");
			if (typeof (default_order) !== "undefined") {
				portlet.find(".filter_order_orientation").val(default_order);
			} else {
				portlet.find(".filter_order_orientation").val("ASC");
			}
		}
		portlet.find(".filter_order_column").val($(this).attr("column-name"));
		onChange();
	});

	// Changement de page
	$(`${portlet_selector} .action-page`).on("click", function () {
		$(`${portlet_selector} .filter_page`).val($(this).attr("page"));
		onChange();
	});


}